module.exports = __webpack_public_path__ + "media/images/jumping/promo-salta-section-bg-04965a0de62176095e5014900732fe6f.jpg";